(function registerListSearch(scope) {
  const normalizeText = (value) => String(value ?? '')
    .toLocaleLowerCase()
    .replace(/[\u00a0\u202f]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const searchDigits = (value) => String(value ?? '').replace(/\D/g, '');

  const parseAmountQuery = (value) => {
    const amount = scope.PlummeMoneyInput.parse(value);
    if (amount == null) return null;
    const normalized = normalizeText(value).replace(/[\u2212\u2013\u2014]/g, '-');
    const signed = /^\s*[-(]/.test(normalized) || /-\s*(?:\w+)?\s*$/.test(normalized) && !/[,.]-\s*$/.test(normalized);
    return { amount, signed };
  };

  const amountMatches = (query, value) => {
    const parsed = parseAmountQuery(query);
    if (value == null || value === '') return false;
    const amount = Number(value);
    if (!parsed || !Number.isFinite(amount)) return false;
    const candidate = parsed.signed ? amount : Math.abs(amount);
    return Math.abs(candidate - parsed.amount) < 0.005;
  };

  const amountScore = (query, value) => {
    if (value == null || value === '') return 0;
    const amount = Number(value);
    if (!Number.isFinite(amount)) return 0;
    const needle = normalizeText(query).replace(/\b(nok|kr)\b/g, '').trim();
    const compactNeedle = needle.replace(/\s/g, '');
    const needleDigits = searchDigits(needle);
    if (!needle && !needleDigits) return 0;
    const abs = Math.abs(amount);
    const integerDigits = String(Math.trunc(abs));
    const centsDigits = String(Math.round(abs * 100));
    const visible = [
      String(amount).replace('.', ','),
      String(abs).replace('.', ','),
      new Intl.NumberFormat('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount),
      new Intl.NumberFormat('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(abs),
    ].map(normalizeText);
    let score = visible.some((text) => text.includes(needle) || text.replace(/\s/g, '').includes(compactNeedle)) ? 55 : 0;
    if (amountMatches(needle, amount)) score = Math.max(score, 120);
    if (!needleDigits) return score;
    if (integerDigits === needleDigits) score = Math.max(score, 115);
    else if (centsDigits === needleDigits) score = Math.max(score, 112);
    else if (integerDigits.startsWith(needleDigits)) score = Math.max(score, 100 - Math.min(30, integerDigits.length - needleDigits.length));
    else if (centsDigits.startsWith(needleDigits)) score = Math.max(score, 88 - Math.min(30, centsDigits.length - needleDigits.length));
    else if (integerDigits.includes(needleDigits)) score = Math.max(score, 62);
    else if (centsDigits.includes(needleDigits)) score = Math.max(score, 48);
    return score;
  };

  const matchScore = (query, { text = [], amounts = [] } = {}) => {
    const needle = normalizeText(query);
    if (!needle) return 1;
    const textScore = text.some((value) => normalizeText(value).includes(needle)) ? 30 : 0;
    const bestAmountScore = amounts.reduce((best, value) => Math.max(best, amountScore(needle, value)), 0);
    return Math.max(textScore, bestAmountScore);
  };

  const matches = (query, { text = [], amounts = [] } = {}) => {
    const needle = normalizeText(query);
    if (!needle) return true;
    return matchScore(needle, { text, amounts }) > 0;
  };

  scope.PlummeListSearch = { normalizeText, parseAmountQuery, amountMatches, amountScore, matchScore, matches };
})(typeof window !== 'undefined' ? window : globalThis);
